import Vue from "vue";
import VueRouter from "vue-router";
import VueMoment from "vue-moment";
import VueLuxon from "vue-luxon";
import VueMq from "vue-mq";
import VueChatScroll from "vue-chat-scroll";

import { mapState } from "vuex";

import moment from "moment";

import router, { applyBeforeEachRouterHook } from "./router";
import store from "./store";
import App from "./App.vue";
import Spinner from "./components/Spinner/";
import Maintenance from "./components/Maintenance.vue";

import { BootstrapVueIcons } from "bootstrap-vue";

Vue.config.productionTip = false;

Vue.use(VueLuxon);
Vue.use(VueRouter);
Vue.use(VueMoment, { moment });
Vue.use(BootstrapVueIcons);
Vue.use(VueMq, {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: Infinity,
  },
});

Vue.use(VueChatScroll);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

applyBeforeEachRouterHook(store);

const isMaintenanceOn = false;

new Vue({
  store,
  router,
  computed: {
    ...mapState(["initialized"]),
  },
  render(h) {
    if (isMaintenanceOn) return h(Maintenance);
    if (!this.initialized) return h(Spinner);
    return h(App);
  },
}).$mount("#app");
